// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-block .right-col-left .ttl h2[data-v-4d292c10],.video-block .right-col-left p[data-v-4d292c10]{will-change:transform}", ""]);
// Exports
module.exports = exports;
